import { render } from "./margin-table.vue?vue&type=template&id=00b5c9b0&scoped=true"
import script from "./margin-table.vue?vue&type=script&lang=js"
export * from "./margin-table.vue?vue&type=script&lang=js"

import "./margin-table.vue?vue&type=style&index=0&id=00b5c9b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b5c9b0"]])

export default __exports__